import { Link } from "react-router-dom";
import NetworkGraph from "../components/NetworkGraph";
import Reveal from "../components/Reveal";
import {
  IconLock, IconTicket, IconCreditCard, IconChart,
  IconGlobe, IconCloud, IconDatabase, IconChat, IconShield,
} from "../components/Icons";

const ACCESS_CARDS = [
  {
    color: "#0066FF",
    bg: "rgba(0,102,255,.1)",
    Icon: IconTicket,
    title: "Abertura de Chamado",
    desc: "Abra, acompanhe e gerencie seus tickets de suporte técnico. Acesse o histórico de atendimentos e status em tempo real.",
    href: "/painel",
    ctaLabel: "Acessar Portal →",
    ctaStyle: "primary",
    footerLabel: "Sistema de Help Desk",
  },
  {
    color: "#22C55E",
    bg: "rgba(34,197,94,.1)",
    Icon: IconCreditCard,
    title: "Financeiro",
    desc: "Acesse seus contratos, itens contratados e faturas geradas para sua empresa.",
    href: "/financeiro",
    ctaLabel: "Acessar Financeiro →",
    ctaStyle: "success",
    footerLabel: "Portal Financeiro",
  },
  {
    color: "#F59E0B",
    bg: "rgba(245,158,11,.1)",
    Icon: IconChart,
    title: "Painéis Administrativos",
    desc: "Acesse os painéis de controle dos seus produtos: cPanel, sepolDRIVE, sepolCHAT, Bitdefender e demais plataformas contratadas.",
    href: "#",
    ctaLabel: "Acessar Painéis →",
    ctaStyle: "warning",
    footerLabel: "Portais de Produto",
  },
];

const PRODUCT_LINKS = [
  { color: "#1A6CF6", Icon: IconGlobe, title: "sepolHOSTING", desc: "cPanel / Webmail", href: "#" },
  { color: "#0091FF", Icon: IconCloud, title: "sepolDRIVE", desc: "Nextcloud", href: "#" },
  { color: "#3ABEFF", Icon: IconDatabase, title: "sepolBACKUP", desc: "Portal de Backup", href: "#" },
  { color: "#00C2A0", Icon: IconChat, title: "sepolCHAT", desc: "Plataforma de Atendimento", href: "#" },
  { color: "#7B3FF2", Icon: IconShield, title: "sepolSECURITY", desc: "Bitdefender GravityZone", href: "#" },
  { color: "#22C55E", Icon: IconChart, title: "ERP Bruning", desc: "Sistema de Gestão", href: "#" },
];

function ctaBackground(kind) {
  if (kind === "success") return "var(--success)";
  if (kind === "warning") return "var(--warning)";
  return null; // "primary" usa a classe btn-primary normal
}

// Decide se o link é interno (rota React, usa <Link>) ou externo/placeholder (usa <a>)
function isInternalHref(href) {
  return href.startsWith("/") && !href.startsWith("//");
}

export default function AreaCliente() {
  return (
    <>
      {/* ═══════════════ ABERTURA ═══════════════ */}
      <section className="page-hero">
        <div className="page-hero__bg"></div>
        <div className="page-hero__grid"></div>
        <NetworkGraph variant="hero" className="page-hero__network" />
        <div className="container" style={{ textAlign: "center" }}>
          <div className="tag animate-up">
            <IconLock style={{ width: "13px", height: "13px" }} />
            Área Exclusiva
          </div>
          <h1
            className="section-title animate-up animate-up--d1"
            style={{ fontSize: "clamp(32px,5vw,52px)" }}
          >
            Área do <span className="text-blue">Cliente</span>
          </h1>
          <p
            className="animate-up animate-up--d2"
            style={{
              fontSize: "17px",
              color: "var(--text-secondary)",
              maxWidth: "500px",
              margin: "16px auto 0",
              lineHeight: "1.7",
            }}
          >
            Selecione abaixo o portal que deseja acessar. Em caso de dúvidas,
            entre em contato com nosso suporte.
          </p>
        </div>
      </section>

      {/* ═══════════════ CARDS DE ACESSO ═══════════════ */}
      <section className="section">
        <div className="container">
          <div className="client-grid">
            {ACCESS_CARDS.map((card, i) => {
              const bgOverride = ctaBackground(card.ctaStyle);
              const internal = isInternalHref(card.href);
              const CtaTag = internal ? Link : "a";
              const ctaProp = internal ? { to: card.href } : { href: card.href };
              return (
                <Reveal
                  className="client-access-card"
                  delay={i * 0.08}
                  style={{ "--card-color": card.color, "--card-bg": card.bg }}
                  key={card.title}
                >
                  <div className="client-access-card__icon" style={{ color: card.color }}>
                    <card.Icon style={{ width: "32px", height: "32px" }} />
                  </div>
                  <div className="client-access-card__title">{card.title}</div>
                  <div className="client-access-card__desc">{card.desc}</div>
                  <CtaTag
                    {...ctaProp}
                    className={bgOverride ? "btn" : "btn btn-primary"}
                    style={
                      bgOverride
                        ? {
                            background: bgOverride,
                            color: card.ctaStyle === "warning" ? "#000" : "#fff",
                            width: "100%",
                            justifyContent: "center",
                          }
                        : undefined
                    }
                  >
                    {card.ctaLabel}
                  </CtaTag>
                  <span style={{ fontSize: "12px", color: "var(--text-muted)" }}>
                    {card.footerLabel}
                  </span>
                </Reveal>
              );
            })}
          </div>

          {/* ═══════════════ PAINÉIS POR PRODUTO ═══════════════ */}
          <div style={{ marginTop: "64px" }}>
            <Reveal
              as="h2"
              style={{
                fontFamily: "var(--font-display)",
                fontSize: "22px",
                fontWeight: 700,
                marginBottom: "8px",
                textAlign: "center",
                color: "var(--text-primary)",
              }}
            >
              Acesso direto por produto
            </Reveal>
            <p
              style={{
                fontSize: "15px",
                color: "var(--text-muted)",
                textAlign: "center",
                marginBottom: "36px",
              }}
            >
              Clique no produto para acessar seu painel de controle
            </p>
            <div className="grid-3col">
              {PRODUCT_LINKS.map((product, i) => {
                const internal = isInternalHref(product.href);
                const ProductTag = internal ? Link : "a";
                const productProp = internal ? { to: product.href } : { href: product.href };
                return (
                  <Reveal
                    as={ProductTag}
                    {...productProp}
                    className="card"
                    delay={i * 0.05}
                    style={{
                      "--accent": product.color,
                      display: "flex",
                      alignItems: "center",
                      gap: "16px",
                      padding: "20px 24px",
                    }}
                    key={product.title}
                  >
                    <span
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "var(--radius-sm)",
                        background: `${product.color}1F`,
                        color: product.color,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <product.Icon style={{ width: "20px", height: "20px" }} />
                    </span>
                    <div>
                      <div style={{ fontWeight: 700, fontSize: "15px", color: "var(--text-primary)" }}>
                        {product.title}
                      </div>
                      <div style={{ fontSize: "12px", color: "var(--text-muted)" }}>
                        {product.desc}
                      </div>
                    </div>
                    <span style={{ color: product.color, marginLeft: "auto" }}>→</span>
                  </Reveal>
                );
              })}
            </div>
          </div>

          {/* ═══════════════ SUPORTE ═══════════════ */}
          <Reveal
            delay={0.15}
            style={{
              marginTop: "48px",
              background: "var(--bg-card)",
              border: "1px solid var(--bg-border)",
              borderRadius: "var(--radius-lg)",
              padding: "32px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "24px",
              flexWrap: "wrap",
            }}
          >
            <div>
              <div style={{ fontWeight: 700, fontSize: "17px", marginBottom: "4px", color: "var(--text-primary)" }}>
                Precisa de ajuda para acessar?
              </div>
              <div style={{ fontSize: "14px", color: "var(--text-muted)" }}>
                Nossa equipe está disponível para auxiliar no acesso aos
                portais.
              </div>
            </div>
            <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
              <Link to="/contato" className="btn btn-outline">
                Fale Conosco
              </Link>
              <a href="mailto:suporte@sepoltech.com.br" className="btn btn-primary">
                suporte@sepoltech.com.br
              </a>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
